import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 SWITCH

    Mismo mecanismo que el checkbox: input real oculto, riel visible.
    La diferencia es semántica, no técnica — un switch aplica el cambio
    al instante; un checkbox espera al submit.
*/

export const FieldSwitch = ({
    id, name, label, hint, error, text,
    isChecked = false, onChange,
    isDisabled = false, span = 1, ...rest
}) => {

    const DOM_ID = useDomFieldId(id);

    return (

    <FieldShell id={DOM_ID} label={label} hint={hint} error={error} layout="inline"
        isDisabled={isDisabled} span={span} >

        <label className={`${BLOCK}__switch`} htmlFor={DOM_ID}>

            <input id={DOM_ID} data-field={name ?? id} name={name ?? id} type="checkbox" role="switch"
                className={`${BLOCK}__switch_input`}
                checked={isChecked} onChange={onChange} disabled={isDisabled}
                {...rest} />

            <span className={`${BLOCK}__switch_track`} aria-hidden="true">
                <span className={`${BLOCK}__switch_dot`} />
            </span>

            {text && <span className={`${BLOCK}__check_text`}>{text}</span>}

        </label>

    </FieldShell>
);
};
